import { lazy } from "react";

const AdvancepaymentPayPetty = lazy(() => import("./AdvancepaymentPayPetty"));

const advancepaymentPayPettyRoutes = [
  {
    path: "/advancepaymentpaypetty/:batchId",
    component: AdvancepaymentPayPetty,
  },
];

export default advancepaymentPayPettyRoutes;
